import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import PaginationComponent from "../../components/PaginationComponent";
import Loader from "../../components/Loader";
import InputField from "../../components/InputField";
import SearchIcon from "@mui/icons-material/Search";
import ReplenishmentRequestTable from "./ReplenishmentRequestTable";
import i18n from "../../constants/Strings";
import { autoReplenishmenetHeaders } from "../../constants/TableConstants";
import useReplenishmentRequestViewController from "../../viewControllers/ReplenishmentRequestViewController/ReplenishmentRequestViewController";

const ReplenishmentRequests = ({}) => {
  const {
    isLoading,
    requests,
    currentPage,
    totalPages,
    handlePageChange,
    status,
    setStatus,
  } = useReplenishmentRequestViewController();

  const text = {
    pageHeading: i18n.t("replenishmentRequests.pageHeading"),
    pendingTab: i18n.t("replenishmentRequests.pendingTab"),
    approvedTab: i18n.t("replenishmentRequests.approvedTab"),
    rejectedTab: i18n.t("replenishmentRequests.rejectedTab"),
    allRequestsTab: i18n.t("replenishmentRequests.allRequestsTab"),
    noPendingRequests: i18n.t("replenishmentRequests.noPendingRequests"),
    noApprovedRequests: i18n.t("replenishmentRequests.noApprovedRequests"),
    noRejectedRequests: i18n.t("replenishmentRequests.noRejectedRequests"),
    noAllRequests: i18n.t("replenishmentRequests.noAllRequests"),
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
            <div className="d-flex justify-space-between">
              
            </div>
          </nav>
          <div className="container-fluid">
            <div className=" mb-4">
              <div className="card-header py-3">
                <h6 className="m-0 font-weight-bold txt-primary">
                  {text.pageHeading}
                </h6>
              </div>

              <Tabs
                defaultActiveKey={status}
                id="fill-tab-example"
                className="mb-3"
                fill
                onSelect={(eventKey) => setStatus(eventKey)}
              >
                <Tab eventKey="pending" title={text.pendingTab}>
                  {requests?.length > 0 ? (
                    <ReplenishmentRequestTable
                      data={requests}
                      headers={autoReplenishmenetHeaders}
                    />
                  ) : (
                    <div className="d-flex justify-content-center mt-5">
                      {text.noPendingRequests}
                    </div>
                  )}
                </Tab>
                <Tab eventKey="approved" title={text.approvedTab}>
                  {requests?.length > 0 ? (
                    <ReplenishmentRequestTable
                      data={requests}
                      headers={autoReplenishmenetHeaders}
                    />
                  ) : (
                    <div className="d-flex justify-content-center mt-5">
                      {text.noApprovedRequests}
                    </div>
                  )}
                </Tab>
                <Tab eventKey="rejected" title={text.rejectedTab}>
                  {requests?.length ? (
                    <ReplenishmentRequestTable
                      data={requests}
                      headers={autoReplenishmenetHeaders}
                    />
                  ) : (
                    <div className="d-flex justify-content-center mt-5">
                      {text.noRejectedRequests}
                    </div>
                  )}
                </Tab>
                <Tab eventKey="" title={text.allRequestsTab}>
                  {requests?.length > 0 ? (
                    <ReplenishmentRequestTable
                      data={requests}
                      headers={autoReplenishmenetHeaders}
                    />
                  ) : (
                    <div className="d-flex justify-content-center mt-5">
                      {text.noAllRequests}
                    </div>
                  )}
                </Tab>
              </Tabs>
              <PaginationComponent
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                data={requests?.length}
              />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default React.memo(ReplenishmentRequests);
